
export default {
  data() {
    return {};
  },
  async asyncData({ $axios, env }) {
    try {
      // 并行处理多个异步请求
      const [recVideoResponse, allVideoResponse] = await Promise.all([
        $axios.$get("/api/video/menu", {
          params: {
            site_id: env.SITE_ID,
            mod_id: "rec",
            size: 10,
            page: 1
          }
        }),
        $axios.$get("/api/video/all_video", {
          params: {
            site_id: env.SITE_ID,
            size: 20,
            page: 1
          }
        })
      ]);
      const allVideoData = [...recVideoResponse.list, ...allVideoResponse.list];
      return {
        recTopThreeVideo: allVideoData.slice(0, 3),
        otherVideos: allVideoData.slice(3)
      };
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
  mounted() {},
  methods: {}
};
